import cx from 'classnames';
import { CSSProperties, ReactNode } from 'react';

import './EnhancedToolTip.scss';

interface EnhancedToolTipProps {
  arrowClassName: string;
  arrowDirection: 'top' | 'top-right' | 'right' | 'bottom' | 'bottom-right' | 'left';
  arrowShadowClassName: string;
  children: ReactNode;
  className: string;
  color: 'black' | 'white';
  shadow: boolean;
  style: CSSProperties;
}

const defaultProps = {
  arrowClassName: '',
  arrowDirection: 'left',
  arrowShadowClassName: '',
  children: null,
  className: '',
  color: 'black',
  shadow: false,
  style: {},
};

function EnhancedToolTip({
  arrowClassName,
  arrowDirection,
  arrowShadowClassName,
  children,
  className,
  color,
  shadow,
  style,
}: EnhancedToolTipProps) {
  if (!children) return null;
  return (
    <div
      className={cx({
        EnhancedToolTip: true,
        [`EnhancedToolTip--${arrowDirection}`]: true,
        [`EnhancedToolTip--${color}`]: true,
        'EnhancedToolTip--shadow': shadow,
        [className]: className,
      })}
      style={style}
    >
      <div className="EnhancedToolTip__background" />
      <div className={cx('EnhancedToolTip__arrow', arrowClassName)} />
      <span className="EnhancedToolTip__text">{children}</span>
      <div className={cx('EnhancedToolTip__arrow-shadow', arrowShadowClassName)} />
    </div>
  );
}

EnhancedToolTip.defaultProps = defaultProps;

export default EnhancedToolTip;
